export default "__VITE_ASSET__CgrW8QUf__"